// extracted by mini-css-extract-plugin
export default {"card":"dashboard_card__7W54g","body":"dashboard_body__zIq2r","image":"dashboard_image__+0hKO"};